var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    filter: "url(#filter0_d_462_2442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval 10 Copy 3",
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8535 37.0049C32.5466 37.0049 39.5937 30.0538 39.5937 21.479C39.5937 12.9043 32.5466 5.95312 23.8535 5.95312C15.1604 5.95312 8.11328 12.9043 8.11328 21.479C8.11328 30.0538 15.1604 37.0049 23.8535 37.0049Z",
    stroke: "#12110B",
    strokeWidth: 0.782013
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M20.2406 18.3511C20.9776 18.3511 21.575 17.7619 21.575 17.0349C21.575 16.308 20.9776 15.7188 20.2406 15.7188C19.5037 15.7188 18.9062 16.308 18.9062 17.0349C18.9062 17.7619 19.5037 18.3511 20.2406 18.3511Z",
    fill: "#12110B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M21.3526 19.2344H19.1286C19.0059 19.2344 18.9062 19.3327 18.9062 19.4537V26.0347C18.9062 26.1558 19.0059 26.2541 19.1286 26.2541H21.3526C21.4753 26.2541 21.575 26.1558 21.575 26.0347V19.4537C21.575 19.3327 21.4753 19.2344 21.3526 19.2344Z",
    fill: "#12110B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M27.9828 18.863C27.0323 18.5419 25.8434 18.824 25.1304 19.3298C25.1059 19.2355 25.0187 19.1653 24.9151 19.1653H22.6911C22.5684 19.1653 22.4688 19.2636 22.4688 19.3847V25.9657C22.4688 26.0868 22.5684 26.185 22.6911 26.185H24.9151C25.0378 26.185 25.1375 26.0868 25.1375 25.9657V21.2361C25.4969 20.9308 25.9599 20.8334 26.3389 20.9922C26.7063 21.1453 26.9166 21.5191 26.9166 22.0171V25.9657C26.9166 26.0868 27.0163 26.185 27.139 26.185H29.363C29.4857 26.185 29.5854 26.0868 29.5854 25.9657V21.5753C29.56 19.7725 28.7002 19.1052 27.9828 18.863Z",
    fill: "#12110B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_462_2442",
    x: 0.684538,
    y: 0.870421,
    width: 46.338,
    height: 45.9122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.34604
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51906
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_462_2442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_462_2442",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.eb1d332dc5f6ae3134b250e427b75c52.svg";
export { ForwardRef as ReactComponent };